// Endpoints da API

const ENDPOINTS = {
    // Auth
    AUTH_LOGIN_STAFF: 'auth/login/staff',
    AUTH_LOGIN_CLIENT: 'auth/login/client',
    AUTH_LOGIN_REFRESH: 'auth/login/refresh/',
    AUTH_LOGOUT: 'auth/logout/',
    AUTH_ME: 'auth/me',
    AUTH_PROFILE: 'v1/auth/profile',
    AUTH_CHANGE_PASSWORD: 'v1/auth/change-password',
    AUTH_REGISTER_CLIENT: 'auth/public/register-client',
    AUTH_VERIFY_EMAIL: 'auth/public/verify-email',
    AUTH_RESEND_EMAIL_CODE: 'auth/public/resend-email-code',

    // FAQ
    FAQ_LIST_PUBLIC: 'faq/public/',
    FAQ_LIST: 'faq/',
    FAQ_DETAIL: 'faq/:id/',

    // News / Blog
    RECENT_NEWS_HOME: 'news/home_latest/',
    NEWS_LIST_PUBLIC: 'news/public/',
    NEWS_DETAIL_LATEST_PUBLIC: 'news/detail_latest/',
    NEWS_DETAIL_PUBLIC: 'news/detail/:slug/',
    NEWS_LIST: 'news/',
    NEWS_DETAIL: 'news/:id/',
    CKEDITOR_UPLOAD: 'ckeditor/upload/',

    // Transparency
    TRANSPARENCY_LIST_PUBLIC: 'news/transparency/',
    TRANSPARENCY_DETAIL_LATEST_PUBLIC: 'news/detail_transparency_latest/',
    TRANSPARENCY_DETAIL_PUBLIC: 'news/detail/transparency/:slug/',

    // Clients (Staff)
    STAFF_CLIENT_LIST: 'v1/staff/clients/',
    STAFF_CLIENT_DETAIL: 'v1/staff/clients/:id/',
    STAFF_CLIENT_APPROVE: 'v1/staff/clients/:id/approve/',
    STAFF_CLIENT_FLAG: 'v1/staff/clients/:id/flag/',

    // Staff (Membros da Equipe)
    STAFF_LIST: 'staff/',
    STAFF_DETAIL: 'staff/:id/',
    STAFF_PERMISSIONS: 'staff/permissions/',

    // Ecommerce
    ECOMMERCE_CATEGORY_LIST: 'v1/ecommerce/categories/',
    ECOMMERCE_CATEGORY_DETAIL: 'v1/ecommerce/categories/:id/',
    ECOMMERCE_PRODUCT_LIST: 'v1/ecommerce/products/',
    ECOMMERCE_PRODUCT_DETAIL: 'v1/ecommerce/products/:id/',
    ECOMMERCE_SHIPPING_RATE_LIST: 'v1/ecommerce/shipping-rates/',
    ECOMMERCE_SHIPPING_RATE_DETAIL: 'v1/ecommerce/shipping-rates/:id/',

    // Ecommerce Public
    ECOMMERCE_CATEGORY_PUBLIC: 'v1/ecommerce/categories/public/',
    ECOMMERCE_PRODUCT_PUBLIC: 'v1/ecommerce/products/public/',
    ECOMMERCE_PRODUCT_PUBLIC_DETAIL: 'v1/ecommerce/products/public/:slug/',
    ECOMMERCE_SHIPPING_RATES_PUBLIC: 'v1/ecommerce/shipping-rates/public/',

    // Cart
    ECOMMERCE_CART: 'v1/ecommerce/cart/',
    ECOMMERCE_CART_ADD_ITEM: 'v1/ecommerce/cart/add-item/',
    ECOMMERCE_CART_UPDATE_ITEM: 'v1/ecommerce/cart/update-item/:id/',
    ECOMMERCE_CART_REMOVE_ITEM: 'v1/ecommerce/cart/remove-item/:id/',
    ECOMMERCE_CART_CLEAR: 'v1/ecommerce/cart/clear/',
    ECOMMERCE_CART_COUNT: 'v1/ecommerce/cart/count/',
    ECOMMERCE_CART_SYNC_PRICES: 'v1/ecommerce/cart/sync-prices/',

    // Orders
    ECOMMERCE_ORDER_LIST: 'v1/ecommerce/orders/',
    ECOMMERCE_ORDER_DETAIL: 'v1/ecommerce/orders/:id/',
    ECOMMERCE_ORDER_PREVIEW: 'v1/ecommerce/orders/preview/',
    ECOMMERCE_ORDER_CREATE: 'v1/ecommerce/orders/',

    // Addresses (Client)
    AUTH_ADDRESS_LIST: 'v1/auth/addresses/',
    AUTH_ADDRESS_DETAIL: 'v1/auth/addresses/:id/',

    // Prescriptions (Client)
    ECOMMERCE_PRESCRIPTION_LIST: 'v1/ecommerce/prescriptions/',
    ECOMMERCE_PRESCRIPTION_DETAIL: 'v1/ecommerce/prescriptions/:id/',

    // Prescriptions (Staff)
    ECOMMERCE_STAFF_PRESCRIPTION_LIST: 'v1/ecommerce/staff/prescriptions/',
    ECOMMERCE_STAFF_PRESCRIPTION_DETAIL: 'v1/ecommerce/staff/prescriptions/:id/',
    ECOMMERCE_STAFF_PRESCRIPTION_VALIDATE: 'v1/ecommerce/staff/prescriptions/:id/validate/',
    ECOMMERCE_STAFF_PRESCRIPTION_INVALIDATE: 'v1/ecommerce/staff/prescriptions/:id/invalidate/',

    // Dashboard (Staff)
    ECOMMERCE_DASHBOARD: 'v1/ecommerce/dashboard/',

    // Payments
    PAYMENTS_ORDER_PIX: 'v1/payments/orders/:id/pix/',

    // Orders (Staff)
    ECOMMERCE_STAFF_ORDER_LIST: 'v1/ecommerce/orders/',
    ECOMMERCE_STAFF_ORDER_DETAIL: 'v1/ecommerce/orders/:id/',
    ECOMMERCE_STAFF_ORDER_UPDATE_STATUS: 'v1/ecommerce/orders/:id/update-status/',

    // Reports (Staff) — Pacientes
    REPORTS_PATIENTS_DEMOGRAPHICS: 'v1/reports/patients/demographics/',
    REPORTS_PATIENTS_OIL_TYPES: 'v1/reports/patients/oil-types/',
    REPORTS_PATIENTS_SOCIAL_DISCOUNTS: 'v1/reports/patients/social-discounts/',
    REPORTS_PATIENTS_REGISTRATIONS: 'v1/reports/patients/registrations/',
    REPORTS_PATIENTS_ACTIVITY: 'v1/reports/patients/activity/',
    REPORTS_PATIENTS_GROWTH: 'v1/reports/patients/growth/',

    // Reports (Staff) — Ecommerce
    REPORTS_ECOMMERCE_PRODUCTS: 'v1/reports/ecommerce/products/',
    REPORTS_ECOMMERCE_DESTINATIONS: 'v1/reports/ecommerce/destinations/',
    REPORTS_ECOMMERCE_REVENUE: 'v1/reports/ecommerce/revenue/',
    REPORTS_ECOMMERCE_DISCOUNTS: 'v1/reports/ecommerce/discounts/',
    REPORTS_ECOMMERCE_GROWTH: 'v1/reports/ecommerce/growth/',
    REPORTS_ECOMMERCE_FREQUENCY: 'v1/reports/ecommerce/frequency/',
    REPORTS_ECOMMERCE_FREQUENCY_DETAIL: 'v1/reports/ecommerce/frequency/detail/',

    // Reports (Staff) — Relatórios Gerados (exportação assíncrona)
    REPORTS_GENERATED_LIST: 'v1/reports/generated/',
    REPORTS_GENERATED_DETAIL: 'v1/reports/generated/:id/',
    REPORTS_GENERATED_DOWNLOAD: 'v1/reports/generated/:id/download/',

    // Site Settings
    SITE_SETTINGS_PUBLIC: 'site-settings/public/',
    SITE_SETTINGS: 'site-settings/',

    // Audit Log (Staff)
    AUDIT_LOG_LIST: 'v1/audit-log/',
    // NEWS: {
    //     LIST: (limit, offset, search = '') =>
    //         `news?limit=${limit}&offset=${offset}&search=${search}`,
    //     DETAIL: (slug) => `news/${slug}`,
    //     RECENT: (slug) => `news/${slug}/recent_news`,
    //     RECENT_HOME: 'news/recent_news_home',
    // },
    //
    // // Products
    // PRODUCTS: {
    //     LIST: (limit, offset, search = '', category = '') =>
    //         `products?limit=${limit}&offset=${offset}&search=${search}&category=${category}`,
    //     DETAIL: (slug) => `products/${slug}`,
    // },
    //
    // // Categories
    // CATEGORIES: 'categories',
    //
    // // Transparency
    // TRANSPARENCY: {
    //     LIST: (limit, offset, search = '') =>
    //         `transparency?limit=${limit}&offset=${offset}&search=${search}`,
    //     DETAIL: (slug) => `transparency/${slug}`,
    //     RECENT: (slug) => `transparency/${slug}/recent_documents`,
    // },
    //
    // // FAQ
    // FAQS: 'faqs',
    //
    // // AME
    // AME: 'ame',
    //
    // // Shop Products (Produtos exclusivos da loja)
    // SHOP_PRODUCTS: {
    //     LIST: (limit, offset, search = '', category = '', minPrice = '', maxPrice = '', orderBy = '') =>
    //         `shop/products?limit=${limit}&offset=${offset}&search=${search}&category=${category}&min_price=${minPrice}&max_price=${maxPrice}&order_by=${orderBy}`,
    //     DETAIL: (slug) => `shop/products/${slug}`,
    //     CATEGORIES: 'shop/categories'
    // },
};

export default ENDPOINTS;
